<div class="loader-box">
  <div class="loader-3"></div>
  <ng-container  *ngIf="text?.length > 0">
    <div class="text">{{text}}</div>
  </ng-container>
</div>
